import { MuiTextfield } from '@apeiron/temp'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { Box, ButtonBase, styled } from '@mui/material'
import * as R from 'ramda'
import { useCallback } from 'react'
import {
  Control,
  FieldValues,
  useController,
  UseControllerProps
} from 'react-hook-form'

const Container = styled(Box)`
  display: flex;
  align-items: center;
  column-gap: 5px;
`

const StyledApeironTextField = styled(MuiTextfield)`
  input {
    text-align: center;
  }
`

const NumberInputWithControl = (props: Props) => {
  const { control, name, defaultValue, rules, className } = props

  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({
    control,
    name,
    defaultValue,
    rules
  })

  const handlePlusClick = useCallback(() => {
    const maxValue =
      typeof rules?.max === 'number'
        ? rules?.max
        : typeof rules?.max === 'object'
        ? rules.max.value
        : undefined

    if (R.isNotNil(maxValue) && value >= maxValue) {
      return
    }

    onChange(Number(value) + 1)
  }, [onChange, rules, value])

  const handleMinusClick = useCallback(() => {
    const minValue =
      typeof rules?.min === 'number'
        ? rules?.min
        : typeof rules?.min === 'object'
        ? rules.min.value
        : undefined

    if (R.isNotNil(minValue) && value <= minValue) {
      return
    }

    onChange(value - 1)
  }, [onChange, rules, value])

  return (
    <Container className={className}>
      <ButtonBase>
        <RemoveCircleOutlineIcon onClick={handleMinusClick} />
      </ButtonBase>
      <StyledApeironTextField
        name={name}
        onChange={onChange}
        value={value}
        type='number'
        error={!!error}
      />
      <ButtonBase>
        <AddCircleOutlineIcon onClick={handlePlusClick} />
      </ButtonBase>
    </Container>
  )
}

type Props = Omit<UseControllerProps, 'control'> & {
  name: string
  control: Control<FieldValues, any>
  defaultValue: number
  className?: string
}

export default NumberInputWithControl
